import Airports from './Airports';
import './Airports.scss';

export default Airports;
